/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol__ = _interopDefault(require('openlayers'));
var uuid = _interopDefault(require('uuid/v4'));
var Vue = _interopDefault(require('vue'));
var minilo = require('../util/minilo');

var Feature = __ol__.Feature;


/**
 * Basic feature initialization
 * @param feature
 */
function initFeature(feature) {
  if (feature.getId() == null) {
    feature.setId(uuid());
  }

  return feature;
}

/**
 * @param {GeoJSONFeature|Vue|ol.Feature|string|number} feature
 * @return {string|number}
 * @throws {Error}
 */
function getFeatureId(feature) {
  var id = void 0;
  if (minilo.isPlainObject(feature) || feature instanceof Vue) {
    id = feature.id;
  } else if (feature instanceof Feature) {
    id = feature.getId();
  } else if (minilo.isString(feature) || minilo.isNumber(feature)) {
    id = feature;
  } else {
    throw new Error('Illegal feature format');
  }

  return id;
}

exports.initFeature = initFeature;
exports.getFeatureId = getFeatureId;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/ol-ext/feature.js
// module id = 170
// module chunks = 1